import { bexioConfigSchema } from './config-schema.js';

export const bexioDefinition = {
  type: 'bexio',
  nameKey: 'nodes.bexio.name',
  subtitleKey: 'nodes.bexio.subtitle',
  modalTitleKey: 'nodes.bexio.title',
  icon: 'business_center',
  color: '#A8C935',
  colorGradient: 'linear-gradient(135deg, #C4D966, #A8C935)',
  iconColor: '#1F2937',
  category: 'allApps',
  schema: bexioConfigSchema
};
